import countries from "./../../../features/profile/countries.json";

export default (values, value) => {
  return countries.map((el) => el.name).includes(value);
};
